"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FormBase;
var _react = _interopRequireDefault(require("react"));
var _CssClassNames = _interopRequireDefault(require("../../scss/CssClassNames"));
var _stylesModule = _interopRequireDefault(require("../FormGroup/styles.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var classNameFnc = new _CssClassNames["default"](_stylesModule["default"], ['utility', 'transition', 'text']).className;
function FormBase(_ref) {
  var wrapperClassName = _ref.wrapperClassName,
    labelClassName = _ref.labelClassName,
    validatorClassName = _ref.validatorClassName,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? '' : _ref$name,
    label = _ref.label,
    error = _ref.error,
    success = _ref.success,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", classNameFnc("form-group ".concat(wrapperClassName ? wrapperClassName : '')), label ? /*#__PURE__*/_react["default"].createElement("label", _extends({
    htmlFor: name
  }, classNameFnc("".concat(labelClassName ? labelClassName : '')), typeof label === 'string' ? {
    dangerouslySetInnerHTML: {
      __html: label
    }
  } : {
    children: label
  })) : null, children, error || success ? /*#__PURE__*/_react["default"].createElement("div", classNameFnc("".concat(error ? 'invalid' : 'valid', "-feedback ").concat(validatorClassName ? validatorClassName : '')), /*#__PURE__*/_react["default"].createElement("span", {
    dangerouslySetInnerHTML: {
      __html: error ? error : success
    }
  })) : null);
}